import { useSelector } from 'react-redux'
import { Icon } from '@iconify/react'

// slices
import { loginState } from '../../modules/login/login.slice'

// styles
import styles from './navigation.module.css'

// routes
import { PRIVATE_ROUTES } from '../../routes'
import { HomeSidebarIcon } from '../../assets/icons'
import {
    canViewClients,
    canViewTalent,
} from '../../helpers/reportsPermission'
// import { canAccessStoryMapMigration } from '../../modules/storyMapMigration/storyMapMigration.utils'

function SuperAdminRoutesNavigation() {
    const { status, userProfile } = useSelector(loginState)

    const profileReady = Boolean(
        status !== 'loading' && userProfile && userProfile?.isSupportUser
    )
    const canSeeClients = profileReady && canViewClients(userProfile)
    const canSeeTalent = profileReady && canViewTalent(userProfile)

    // const canSeeMigration = canAccessStoryMapMigration(userProfile)

    const adminNavItems = []

    if (canSeeClients) {
        adminNavItems.push({
            key: 'clients',
            route: PRIVATE_ROUTES.clients,
            label: 'Clients ',
            icon: (
                <Icon
                    icon="ph:users"
                    className={styles.icon + ' ' + styles.clientIcon}
                    width={20}
                    height={20}
                />
            ),
        })
    }

    if (canSeeTalent) {
        adminNavItems.push({
            key: 'talent',
            route: PRIVATE_ROUTES.talent,
            label: 'Talent',
            icon: (
                <Icon
                    icon="ph:user-list"
                    className={styles.icon}
                    width={20}
                    height={20}
                />
            ),
        })
    }

    // if (canSeeMigration) {
    //     adminNavItems.push({
    //         key: 'admin',
    //         route: PRIVATE_ROUTES.storyMapMigration,
    //         label: 'Story Map Migration',
    //         icon: (
    //             <Icon
    //                 icon="mdi:database-arrow-right"
    //                 className={styles.icon}
    //                 width={20}
    //                 height={20}
    //             />
    //         ),
    //     })
    // }

    return [
        {
            key: 'home',
            route: PRIVATE_ROUTES.home,
            label: 'Home',
            icon: (
                <span className={styles.icon}>
                    <HomeSidebarIcon />
                </span>
            ),
        },
        ...adminNavItems,
    ]
}

export default SuperAdminRoutesNavigation
